var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fundo-layout {\n    background: url(" + escape(require("../../../assets/img/capa.jpg")) + "), #70C1ED;\n    background: url(" + escape(require("../../../assets/img/capa.jpg")) + "), linear-gradient(to left, #D7ECFB, #70C1ED);\n    background-attachment: fixed;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n}\n\n.img-avatar-topo {\n    max-height: 90px;\n    margin: auto;\n    padding: 8px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/containers/simple-layout/simple-leyout.component.css
// module id = ../../../../../src/app/containers/simple-layout/simple-leyout.component.css
// module chunks = main